<div class="grid grid-nogutter">
  <div class="col-12 lg:col-7">
    <p class="text-black-400 p3 font-semibold mt-0 mb-2" data-cy="insurance-details-plan-label">Insurance Plan</p>
    <p class="mt-0 mb-4 p3" data-cy="insurance-details-plan-value">
      {{ insurance.insurancePlan }}
    </p>

    <p class="text-black-400 p3 font-semibold mt-0 mb-2" data-cy="insurance-details-name-of-insured-label">
      Name of Insured
    </p>
    <p class="mt-0 mb-4 p3" data-cy="insurance-details-name-of-insured-value">
      {{ insurance.nameOfInsured || (patient$ | async)?.fullName }}
    </p>

    <p
      *ngIf="insurance.relationshipToInsured"
      class="text-black-400 p3 font-semibold mt-0 mb-2"
      data-cy="insurance-details-relationship-label"
    >
      Relationship to Insured
    </p>
    <p class="mt-0 mb-4 lg:mb-0 p3" data-cy="insurance-details-relationship-value">
      {{ insurance.relationshipToInsured }}
    </p>
  </div>
  <div class="col-12 lg:col-5">
    <p class="text-black-400 p3 font-semibold mt-0 mb-2" data-cy="insurance-details-number-label">Insurance Number</p>
    <p class="mt-0 mb-4 p3" data-cy="insurance-details-number-value">
      {{ insurance.insuranceNumber?.replace(insuranceMask, '*') }}
    </p>
    <p class="text-black-400 p3 font-semibold mt-0 mb-2" data-cy="insurance-details-group-number-label">Group Number</p>
    <p class="mt-0 mb-0 lg:mb-4 p3" data-cy="insurance-details-group-number-value">
      {{ insurance.groupNumber }}
    </p>
  </div>
</div>
